import React from 'react';
import reduxFetch from 'react-redux-fetch';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { ACCESS_RIGHTS_RESOURCE } from './accessRightsService';
import { VEHICLE_ACCESS_RIGHTS_RESOURCE } from '../../vehicleSidebar/services/vehicleAccessRightsService';
import { getErrorCodeConvertor } from '../../app/lib/errorCodeConvertor';
import { OFF_PREMISE_ACCESS_RIGHTS_RESOURCE } from '../../requests/services/offPremiseAccessRightsService';
import { ON_PREMISE_ACCESS_RIGHTS_RESOURCE } from '../constants';
import { OFF_PREMISE_VEHICLE_ACCESS_RIGHTS_RESOURCE } from '../../vehicleSidebar/services/offPremiseVehicleAccessRightsService';
import { ON_PREMISE_VEHICLE_ACCESS_RIGHTS_RESOURCE } from '../../vehicleSidebar/services/onPremiseVehicleAccessRightsService';
import apiRoutes from '../../../app/api/routes';
import { PRIVATE_VEHICLES_RESOURCE } from '../../vehicles/constants';

export default ComposedComponent =>
  compose(
    withTranslation(),
    reduxFetch(props => [
      {
        resource: 'deleteAccessRight',
        method: 'delete',
        request: (accessRightId, callback, vehicleId) => {
          const updateOtherLists = [];

          if (vehicleId) {
            updateOtherLists.push({
              resource: PRIVATE_VEHICLES_RESOURCE,
              listPath: 'values',
              idProp: 'id',
              id: vehicleId,
              values: {
                hasActiveAccessRights: false,
              },
            });
          }

          return {
            url: apiRoutes.accessRight(accessRightId),
            meta: {
              toaster: {
                onSuccessMessage: props.t('accessRightDeleteSuccess'),
                onErrorMessage: getErrorCodeConvertor(props.t, 'accessRightDeleteErr'),
              },
              callback,
              updateOtherLists,
              removeFromOtherLists: [
                {
                  id: accessRightId,
                  idProp: 'id',
                  listPath: 'values',
                  resource: ACCESS_RIGHTS_RESOURCE,
                },
                {
                  id: accessRightId.trim(),
                  idProp: 'id',
                  listPath: 'values',
                  resource: VEHICLE_ACCESS_RIGHTS_RESOURCE,
                },
                {
                  id: accessRightId.trim(),
                  idProp: 'id',
                  listPath: 'values',
                  resource: ON_PREMISE_ACCESS_RIGHTS_RESOURCE,
                },
                {
                  id: accessRightId.trim(),
                  idProp: 'id',
                  listPath: 'values',
                  resource: OFF_PREMISE_VEHICLE_ACCESS_RIGHTS_RESOURCE,
                },
                {
                  id: accessRightId.trim(),
                  idProp: 'id',
                  listPath: 'values',
                  resource: ON_PREMISE_VEHICLE_ACCESS_RIGHTS_RESOURCE,
                },
                {
                  id: accessRightId.trim(),
                  idProp: 'id',
                  listPath: 'values',
                  resource: OFF_PREMISE_ACCESS_RIGHTS_RESOURCE,
                },
              ],
            },
          };
        },
      },
    ])
  )(props => <ComposedComponent {...props} />);
